// web/src/features/home/homeStyles.ts
// Shared visual tokens for the Home widget canvas, kept in one place so the
// canvas matches the app design system: the shared <Card> frame, the dense
// list-row hover, and brand chart colours. Each value mirrors a design token in
// web/src/index.css (or the shared <Card> component) — noted inline.

// Widget frame — the visual half of the shared <Card>. The structural
// flex/overflow classes stay inline on WidgetCard because a widget must fill its
// grid cell, which the self-sizing <Card> component does not do.
// Mirrors <Card> (rounded-card, --frame-border, shadow-card). The frame is one
// step darker than the hairline so widgets read as bordered on the canvas.
export const CARD_FRAME = 'rounded-card border border-frame bg-surface shadow-card';

// Compact tiles (KPI): the same frame as the big one, so the canvas reads as
// one system. Mirrors <Card> (rounded-card, --frame-border, shadow-card).
export const COMPACT_FRAME = 'rounded-card border border-frame bg-surface shadow-card';

// Card/section title — 12px (text-meta), the main-nav menu font size.
export const CARD_TITLE = 'text-meta font-semibold text-primary-text tracking-tight';

// Shared base for compact list/nav rows inside widgets. Compose with
// `flex items-center gap-2` where a row has multiple children.
export const LIST_ROW = 'rounded-md px-2 py-1 text-body transition hover:bg-row-highlight';

// Dotted alignment-grid dot colour for customize mode. A functional guide (not
// brand chrome), so it uses a medium slate that reads clearly on the white
// canvas rather than a faint border tint.
export const GRID_DOT = '#94a3b8';

// Brand-aligned chart colours (mirror the design tokens). Per-widget accent
// icon colours are intentionally NOT part of this set — they stay semantic.
export const CHART = {
  series: '#086f87', // --primary
  grid: '#e7eaef',   // --border-light
  axis: '#6A655E',   // --text-muted
} as const;
